// Patients
const PatientList = () => import('@/views/patients/PatientList.vue')
const PatientForm = () => import('@/views/patients/PatientForm.vue')
const PatientView = () => import('@/views/patients/PatientView.vue')
const PatientDetails = () => import('@/views/patients/PatientDetails.vue')
const PatientVerifications = () => import('@/views/patients/PatientVerifications.vue')
const PatientFaxes = () => import('@/views/patients/PatientFaxes.vue')

// Documents
const DocumentList = () => import('@/views/documents/DocumentList.vue')
const DocumentForm = () => import('@/views/documents/DocumentForm.vue')
const DocumentView = () => import('@/views/documents/DocumentView.vue')

// Appointments
const AppointmentsList = () => import('@/views/appointments/AppointmentsList.vue')
const AppointmentForm = () => import('@/views/appointments/AppointmentForm.vue')
const AppointmentView = () => import('@/views/appointments/AppointmentView.vue')

// Insurance
const InsuranceList = () => import('@/views/insurance/InsuranceList.vue')
const InsuranceForm = () => import('@/views/insurance/InsuranceForm.vue')
const InsuranceView = () => import('@/views/insurance/InsuranceView.vue')

export const patientRoutes = [
  {
    path: '/patients',
    name: 'Patients',
    component: PatientList,
    meta: {
      requiresAuth: true,
      title: 'Patients'
    }
  },
  {
    path: '/patients/new',
    name: 'NewPatient',
    component: PatientForm,
    meta: {
      requiresAuth: true,
      title: 'New Patient'
    }
  },
  {
    path: '/patients/:patientId',
    component: PatientView,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/patients/:patientId/edit',
        name: 'EditPatient',
        component: PatientForm,
        meta: {
          requiresAuth: true,
          title: 'Edit Patient'
        }
      },
      {
        path: '',
        name: 'ViewPatient',
        component: PatientDetails,
        meta: {
          requiresAuth: true,
          title: 'Patient Details'
        }
      },
      {
        path: 'verifications',
        name: 'PatientVerifications',
        component: PatientVerifications,
        meta: {
          requiresAuth: true,
          title: 'Patient Verifications'
        }
      },
      {
        path: 'faxes',
        name: 'PatientFaxes',
        component: PatientFaxes,
        meta: {
          requiresAuth: true,
          title: 'Patient Faxes'
        }
      },
      {
        path: 'documents',
        name: 'PatientDocuments',
        component: DocumentList,
        meta: {
          requiresAuth: true,
          title: 'Patient Documents'
        }
      },
      {
        path: 'documents/new',
        name: 'NewPatientDocument',
        component: DocumentForm,
        meta: {
          requiresAuth: true,
          title: 'New Document'
        }
      },
      {
        path: 'documents/:id',
        name: 'ViewPatientDocument',
        component: DocumentView,
        meta: {
          requiresAuth: true,
          title: 'View Document'
        }
      },
      {
        path: 'documents/:id/edit',
        name: 'EditPatientDocument',
        component: DocumentForm,
        meta: {
          requiresAuth: true,
          title: 'Edit Document'
        }
      },
      {
        path: 'appointments',
        name: 'PatientAppointments',
        component: AppointmentsList,
        meta: {
          requiresAuth: true,
          title: 'Patient Appointments'
        },
        children: [
          {
            path: 'new',
            name: 'NewPatientAppointment',
            component: AppointmentForm,
            meta: {
              requiresAuth: true,
              title: 'New Patient Appointment'
            }
          },
          {
            path: ':appointmentId',
            name: 'ViewPatientAppointment',
            component: AppointmentView,
            meta: {
              requiresAuth: true,
              title: 'View Patient Appointment'
            }
          },
          {
            path: ':appointmentId/edit',
            name: 'EditPatientAppointment',
            component: AppointmentForm,
            meta: {
              requiresAuth: true,
              title: 'Edit Patient Appointment'
            }
          }
        ]
      },
      {
        path: 'insurance',
        name: 'PatientInsurance',
        component: InsuranceList,
        meta: {
          requiresAuth: true,
          title: 'Patient Insurance'
        },
        children: [
          {
            path: 'new',
            name: 'NewPatientInsurance',
            component: InsuranceForm,
            meta: {
              requiresAuth: true,
              title: 'New Patient Insurance'
            }
          },
          {
            path: ':insuranceId/view',
            name: 'ViewPatientInsurance',
            component: InsuranceView,
            meta: {
              requiresAuth: true,
              title: 'View Patient Insurance'
            }
          },
          {
            path: ':insuranceId/edit',
            name: 'EditPatientInsurance',
            component: InsuranceForm,
            meta: {
              requiresAuth: true,
              title: 'Edit Patient Insurance'
            }
          }
        ]
      }
    ]
  }
]
